<template>
  <v-app class="modern-app">
    <div class="modern-bg">
      <div class="gradient-circle gc-1"></div>
      <div class="gradient-circle gc-2"></div>
    </div>

    <v-app-bar
      app
      flat
      class="modern-header mx-auto mt-4"
      height="78"
      style="max-width: 1280px"
    >
      <v-btn icon @click="$router.back()">
        <v-icon color="#111827">mdi-arrow-left</v-icon>
      </v-btn>

      <div class="ml-3">
        <div class="header-title">
          {{ ($route.query.nama || "Layanan OPD").toUpperCase() }}
        </div>

        <div class="header-subtitle">{{ totalLayanan }} layanan tersedia</div>
      </div>

      <v-spacer />

      <v-text-field
        v-model="search"
        dense
        solo
        flat
        hide-details
        prepend-inner-icon="mdi-magnify"
        placeholder="Cari layanan..."
        class="search-box"
      ></v-text-field>
    </v-app-bar>

    <v-main>
      <v-container class="content-wrapper py-10" style="max-width: 1280px">
        <div class="chips-wrapper mb-8">
          <v-chip
            class="mr-2 mb-2"
            :color="selectedGroup === 'all' ? '#10b981' : ''"
            :text-color="selectedGroup === 'all' ? 'white' : '#374151'"
            @click="selectedGroup = 'all'"
          >
            Semua
          </v-chip>

          <v-chip
            v-for="(items, groupName) in groupedLayanan"
            :key="groupName"
            class="mr-2 mb-2"
            :color="selectedGroup === groupName ? '#10b981' : ''"
            :text-color="selectedGroup === groupName ? 'white' : '#374151'"
            @click="selectedGroup = groupName"
          >
            {{ groupName }}
          </v-chip>
        </div>

        <div class="d-flex align-center mb-6">
          <div class="group-line mr-4"></div>

          <div>
            <div class="group-title">
              {{ selectedGroup === "all" ? "Semua Layanan" : selectedGroup }}
            </div>

            <div class="group-subtitle">{{ filteredCards.length }} layanan</div>
          </div>
        </div>

        <v-row>
          <v-col
            v-for="item in filteredCards"
            :key="item.id"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card class="service-card" elevation="0" @click="showDetail(item)">
              <div class="service-image-wrapper">
<div
  v-if="isCCTV(item)"
  class="cctv-wrapper"
  :data-id="item.id"
>
  <img
    v-if="visibleCctv[item.id]"
    :src="getCctvImage(item)"
    class="cctv-image"
    loading="lazy"
    @error="handleImageError(item)"
  />

  <img
    v-else
    :src="item.full_url"
    class="cctv-image"
  />

  <div class="image-overlay"></div>

  <div class="live-badge">
    <div class="live-dot"></div>
    LIVE
  </div>
</div>

<v-img
  v-else
  :src="item.full_url"
  height="190"
  cover
  class="service-image"
>
  <div class="image-overlay"></div>

  <div class="service-status">
    <div class="status-dot"></div>
    AKTIF
  </div>
</v-img>
<v-img
  v-else
  :src="item.full_url"
  height="190"
  cover
  class="service-image"
>
  <div class="image-overlay"></div>

  <div class="service-status">
    <div class="status-dot"></div>
    AKTIF
  </div>
</v-img>
                  <div class="image-overlay"></div>

                  <div class="service-status">
                    <div class="status-dot"></div>
                    AKTIF
                  </div>
                </v-img>
              </div>

              <div class="service-content">
                <div class="service-title">
                  {{ item.nama_layanan }}
                </div>

                <div class="service-description">
                  {{ item.deskripsi || "Layanan publik digital Bondowoso" }}
                </div>

                <div class="service-footer">
                  <div class="service-chip">ONLINE</div>

                  <v-btn icon small color="#10b981">
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <div
          v-if="Object.keys(filteredGroupedLayanan).length === 0"
          class="text-center py-16"
        >
          <v-icon size="90" color="#d1d5db"> mdi-folder-search-outline </v-icon>

          <div class="empty-title mt-5">Layanan tidak ditemukan</div>
        </div>
      </v-container>
    </v-main>

    <v-dialog v-model="iframeDialog" fullscreen transition="dialog-bottom-transition">
      <v-card class="iframe-card">
        <v-toolbar flat color="black">

          <v-toolbar-title class="iframe-title white--text">
            {{ selectedItem.nama_layanan }}
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            v-if="selectedItem.link_layanan"
            color="#d43535"
            dark
            rounded
            small
             @click="iframeDialog = false"
          >
          <v-icon color="#ffffff"> mdi-close </v-icon>
            TUTUP
          </v-btn>
        </v-toolbar>

        <div class="iframe-wrapper">
  <iframe
    :src="selectedUrl"
    class="full-iframe"
    frameborder="0"
    allowfullscreen
  ></iframe>
</div>
      </v-card>
    </v-dialog>
<v-dialog v-model="detailDialog" max-width="620">
  <v-card class="detail-card">
    <v-img
      :src="selectedItem.full_url"
      height="220"
      cover
    >
      <div class="detail-overlay"></div>

      <div class="detail-status">
        <div class="status-dot"></div>
        AKTIF
      </div>
    </v-img>

    <v-card-text class="pa-6">
      <div class="detail-title">
        {{ selectedItem.nama_layanan }}
      </div>

      <div class="detail-description">
        {{
          selectedItem.deskripsi ||
          "Layanan publik digital Kabupaten Bondowoso"
        }}
      </div>

      <div class="detail-actions mt-6">
        <v-btn
          color="#10b981"
          dark
          large
          rounded
          @click="openIframe(selectedItem)"
        >
          <v-icon left>mdi-eye</v-icon>
          Lihat Detail
        </v-btn>

      </div>
    </v-card-text>
  </v-card>
</v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import { getLayananPublik } from "@/api/androidInitApi";

export default {
  data() {
    return {
      items: [],
      search: "",
      selectedGroup: "all",

      iframeDialog: false,
      selectedUrl: "",
      selectedItem: {},
      visibleCctv: {},
      observer: null,
      detailDialog: false,
    };
  },

  computed: {
    filteredCards() {
      if (this.selectedGroup === "all") {
        return this.filteredItems;
      }

      return this.filteredItems.filter((i) => i.nama_layanan === this.selectedGroup);
    },
    totalLayanan() {
      return this.filteredItems.length;
    },

    filteredItems() {
      return this.items.filter(
        (i) =>
          i.opd_id == this.$route.params.opd_id &&
          (i.nama_layanan?.toLowerCase().includes(this.search.toLowerCase()) ||
            i.deskripsi?.toLowerCase().includes(this.search.toLowerCase()))
      );
    },

    groupedLayanan() {
      return this.filteredItems.reduce((acc, obj) => {
        const key = obj.nama_layanan;

        if (!acc[key]) {
          acc[key] = [];
        }

        acc[key].push(obj);

        return acc;
      }, {});
    },

    filteredGroupedLayanan() {
      if (this.selectedGroup === "all") {
        return this.groupedLayanan;
      }

      return {
        [this.selectedGroup]: this.groupedLayanan[this.selectedGroup],
      };
    },
    
    cctvItems() {
    return this.items.filter(item =>
      item.nama_layanan?.toLowerCase().includes("cctv")
    );
  }
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    initObserver() {
  this.$nextTick(() => {
    const cards = document.querySelectorAll(".cctv-wrapper");

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.dataset.id;

          if (entry.isIntersecting) {
            this.$set(this.visibleCctv, id, true);
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    cards.forEach((el) => {
      this.observer.observe(el);
    });
  });
},

showDetail(item) {
  this.selectedItem = item;
  this.detailDialog = true;
},

openIframe(item) {
  if (!item.link_layanan) return;

  this.selectedItem = item;

  this.selectedUrl = this.transformUrl(item.link_layanan);

  this.detailDialog = false;
  this.iframeDialog = true;
},
    getCctvImage(item) {
  try {
    const urlObj = new URL(item.link_layanan);

    const mid = urlObj.searchParams.get("mid");

    return `https://cctv.bondowosokab.go.id/cgi-bin/nph-zms?mode=jpeg&scale=50&maxfps=5&monitor=${mid}&user=view&pass=K0minfo`;
  } catch (e) {
    return item.full_url;
  }
},
    isCCTV(item) {
  return (
    item.nama_layanan &&
    item.nama_layanan.toLowerCase().includes("cctv")
  );
},
async fetchData() {
  try {
    this.items = (await getLayananPublik()) || [];

    const layananOpd = this.items.filter(
      (i) => i.opd_id == this.$route.params.opd_id
    );

    const isCctvCategory = layananOpd.some(
      (i) => i.nama_layanan?.toLowerCase().includes("cctv")
    );

    if (isCctvCategory) {
      this.$router.replace("/cctvpage");
      return;
    }

    this.$nextTick(() => {
      this.initObserver();
    });
  } catch (e) {
    console.error("API Error:", e);
  }
},

    transformUrl(url) {
      if (url && url.includes("cctv.bondowosokab.go.id")) {
        try {
          const urlObj = new URL(url);

          const mid = urlObj.searchParams.get("mid");

          if (mid) {
            return `https://cctv.bondowosokab.go.id/cgi-bin/nph-zms?scale=100&mode=jpeg&maxfps=30&monitor=${mid}&user=view&pass=K0minfo&rand=${Math.random()}`;
          }
        } catch (e) {
          return url;
        }
      }

      return url;
    },
  },
};
</script>

<style scoped>
.detail-card {
  border-radius: 28px !important;
  overflow: hidden;
}

.detail-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0,0,0,0.55),
    transparent
  );
}

.detail-status {
  position: absolute;
  top: 16px;
  left: 16px;

  background: rgba(255,255,255,0.9);
  backdrop-filter: blur(10px);

  border-radius: 999px;

  padding: 7px 14px;

  display: flex;
  align-items: center;
  gap: 6px;

  font-size: 11px;
  font-weight: 700;
}

.detail-title {
  font-size: 24px;
  font-weight: 800;
  color: #111827;
}

.detail-description {
  margin-top: 12px;

  color: #6b7280;
  line-height: 1.8;

  font-size: 14px;
}

.detail-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.cctv-image {
  width: 100%;
  height: 190px;
  object-fit: cover;
  display: block;
  background: black;
}
.cctv-wrapper {
  position: relative;
  width: 100%;
  height: 190px;
  overflow: hidden;
  background: black;
}

.cctv-frame {
  width: 100%;
  height: 100%;
  border: none;
  pointer-events: none;
}

.live-badge {
  position: absolute;
  top: 12px;
  left: 12px;

  background: rgba(255,255,255,0.9);
  backdrop-filter: blur(10px);

  border-radius: 999px;

  padding: 6px 12px;

  display: flex;
  align-items: center;
  gap: 6px;

  font-size: 11px;
  font-weight: 700;

  color: #111827;
}

.live-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: red;

  animation: livePulse 1s infinite;
}

@keyframes livePulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.5;
    transform: scale(1.3);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.modern-app {
  background: #f8fafc;
}

.modern-bg {
  position: fixed;
  inset: 0;
  overflow: hidden;
  z-index: 0;
}

.gradient-circle {
  position: absolute;
  border-radius: 999px;
  filter: blur(120px);
  opacity: 0.15;
}

.gc-1 {
  width: 500px;
  height: 500px;
  background: #10b981;
  top: -120px;
  left: -120px;
}

.gc-2 {
  width: 500px;
  height: 500px;
  background: #f59e0b;
  bottom: -150px;
  right: -150px;
}

.modern-header {
  border-radius: 24px !important;
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(18px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.header-title {
  font-size: 18px;
  font-weight: 800;
  color: #111827;
  letter-spacing: 0.5px;
}

.header-subtitle {
  font-size: 12px;
  color: #6b7280;
}

.search-box {
  max-width: 260px;
}

.content-wrapper {
  position: relative;
  z-index: 1;
}

.group-line {
  width: 5px;
  height: 45px;
  border-radius: 999px;
  background: linear-gradient(to bottom, #10b981, #059669);
}

.group-title {
  font-size: 24px;
  font-weight: 800;
  color: #111827;
}

.group-subtitle {
  font-size: 13px;
  color: #6b7280;
}

.service-card {
  border-radius: 24px !important;
  overflow: hidden;
  background: white !important;
  transition: all 0.25s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.service-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.service-image-wrapper {
  position: relative;
}

.image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
}

.service-status {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;

  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);

  padding: 6px 10px;
  border-radius: 999px;

  display: flex;
  align-items: center;
  gap: 6px;

  font-size: 11px;
  font-weight: 700;
  color: #111827;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #10b981;
}

.service-content {
  padding: 18px;
}

.service-title {
  font-size: 17px;
  font-weight: 700;
  color: #111827;
}

.service-description {
  margin-top: 8px;

  color: #6b7280;
  font-size: 13px;
  line-height: 1.7;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.service-footer {
  margin-top: 16px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.service-chip {
  background: #ecfdf5;
  color: #059669;

  font-size: 11px;
  font-weight: 700;

  padding: 7px 12px;
  border-radius: 999px;
}

.empty-title {
  font-size: 18px;
  font-weight: 700;
  color: #6b7280;
}

.iframe-card {
  background: white;
}

.iframe-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.iframe-wrapper {
  width: 100%;
  height: calc(100vh - 64px);

  display: flex;
  align-items: center;
  justify-content: center;

  background: #000;

  overflow: hidden;
}

.full-iframe {
  width: 95%;
  height: 95%;

  border: none;
  border-radius: 18px;

  background: #000;

  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.35);
}

@media (max-width: 768px) {
  .modern-header {
    margin: 10px !important;
    border-radius: 18px !important;
  }

  .search-box {
    max-width: 150px;
  }

  .group-title {
    font-size: 20px;
  }
}
</style>
